import React from "react";
import { NavLink } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Factory, Flame, Package, Tablet, Monitor, ArrowRight, Scissors, Shirt } from "lucide-react";

const STAGES = [
  { key: "printing", label: "Printing", icon: Factory, desc: "Print the design onto sublimation paper" },
  { key: "fusing", label: "Fusing", icon: Flame, desc: "Transfer print to base fabric → finished fabric roll" },
  { key: "cutting", label: "Cutting", icon: Scissors, desc: "Cut finished fabric to the approved pattern" },
  { key: "stitching", label: "Stitching", icon: Shirt, desc: "Stitch cut panels into finished products" },
  { key: "packing", label: "Bundle Packing", icon: Package, desc: "Bundle & count finished products for inventory" },
];

export default function ProductionHub() {
  return (
    <div className="space-y-8" data-testid="production-hub">
      <div>
        <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Production</h2>
        <p className="mt-1 text-sm text-slate-500">Printing → Fusing → Cutting → Stitching → Bundle Packing. Choose a stage and your workspace.</p>
      </div>

      <div className="grid gap-6 lg:grid-cols-3">
        {STAGES.map((s) => {
          const Icon = s.icon;
          return (
            <Card key={s.key} className="flex flex-col p-6" data-testid={`stage-card-${s.key}`}>
              <div className="flex h-11 w-11 items-center justify-center rounded-md bg-indigo-50 text-indigo-600">
                <Icon className="h-5 w-5" />
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-slate-900">{s.label}</h3>
              <p className="mt-1 text-sm text-slate-500">{s.desc}</p>
              <div className="mt-5 flex flex-col gap-2">
                <NavLink to={`/production/${s.key}`} data-testid={`open-operator-${s.key}`}
                  className="flex items-center justify-between rounded-md border border-slate-200 px-4 py-2.5 text-sm font-medium text-slate-700 transition-colors hover:border-indigo-300 hover:bg-indigo-50">
                  <span className="flex items-center gap-2"><Tablet className="h-4 w-4" />Operator Workspace</span>
                  <ArrowRight className="h-4 w-4" />
                </NavLink>
                <NavLink to={`/production/${s.key}/control`} data-testid={`open-supervisor-${s.key}`}
                  className="flex items-center justify-between rounded-md border border-slate-200 px-4 py-2.5 text-sm font-medium text-slate-700 transition-colors hover:border-indigo-300 hover:bg-indigo-50">
                  <span className="flex items-center gap-2"><Monitor className="h-4 w-4" />Supervisor Dashboard</span>
                  <ArrowRight className="h-4 w-4" />
                </NavLink>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
